<template>
    <div v-if="avisos && avisos.length > 0" class="avisos-banner-container">
        <transition name="fade" mode="out-in">
            <div 
                :key="avisoAtual.id_aviso"
                class="aviso-banner"
                :style="{ backgroundColor: avisoAtual.cor || '#2196F3' }"
            >
                <v-container class="py-2">
                    <v-row align="center" no-gutters>
                        <v-col cols="1" class="text-center">
                            <v-icon color="white" size="24">mdi-alert</v-icon>
                        </v-col>
                        <v-col cols="10" class="px-2">
                            <div class="aviso-content">
                                <div class="aviso-titulo">{{ avisoAtual.titulo }}</div>
                                <div class="aviso-corpo">{{ avisoAtual.corpo }}</div>
                            </div>
                        </v-col>
                        <v-col cols="1" class="text-center">
                            <div v-if="avisos.length > 1" class="aviso-indicador">
                                {{ indiceAtual + 1 }}/{{ avisos.length }}
                            </div>
                        </v-col>
                    </v-row>
                </v-container>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    name: 'AvisosBanner',
    props: {
        avisos: {
            type: Array,
            default: () => []
        },
        intervalo: {
            type: Number,
            default: 5000 // 5 segundos por padrão
        }
    },
    data() {
        return {
            indiceAtual: 0,
            timer: null
        };
    },
    computed: {
        avisoAtual() {
            if (this.avisos && this.avisos.length > 0) {
                return this.avisos[this.indiceAtual];
            }
            return null;
        }
    },
    watch: {
        avisos: {
            immediate: true,
            handler(newVal) {
                if (newVal && newVal.length > 0) {
                    this.iniciarRotacao();
                } else {
                    this.pararRotacao();
                }
            }
        }
    },
    mounted() {
        if (this.avisos && this.avisos.length > 0) {
            this.iniciarRotacao();
        }
    },
    beforeDestroy() {
        this.pararRotacao();
    },
    methods: {
        iniciarRotacao() {
            this.pararRotacao();
            
            if (this.avisos && this.avisos.length > 1) {
                this.timer = setInterval(() => {
                    this.indiceAtual = (this.indiceAtual + 1) % this.avisos.length;
                }, this.intervalo);
            }
        },
        pararRotacao() {
            if (this.timer) {
                clearInterval(this.timer);
                this.timer = null;
            }
        }
    }
};
</script>

<style scoped>
.avisos-banner-container {
    width: 100%;
    margin-bottom: 16px;
}

.aviso-banner {
    width: 100%;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    overflow: hidden;
    transition: all 0.3s ease;
}

.aviso-content {
    color: white;
    text-align: left;
}

.aviso-titulo {
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 4px;
    line-height: 1.2;
}

.aviso-corpo {
    font-size: 12px;
    line-height: 1.3;
    opacity: 0.95;
}

.aviso-indicador {
    color: white;
    font-size: 10px;
    font-weight: bold;
    background-color: rgba(0, 0, 0, 0.2);
    border-radius: 10px;
    padding: 2px 6px;
    display: inline-block;
}

/* Transição de fade */
.fade-enter-active, .fade-leave-active {
    transition: opacity 0.5s ease;
}

.fade-enter, .fade-leave-to {
    opacity: 0;
}

/* Responsividade */
@media (max-width: 600px) {
    .aviso-titulo {
        font-size: 13px;
    }
    
    .aviso-corpo {
        font-size: 11px;
    }
    
    .aviso-indicador {
        font-size: 9px;
        padding: 2px 4px;
    }
}

@media (max-width: 400px) {
    .aviso-titulo {
        font-size: 12px;
    }
    
    .aviso-corpo {
        font-size: 10px;
    }
}
</style>
